import { Component, OnInit, HostBinding } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService, ToolsService } from '@argalis-apps/angular-global';
import { MDomain, MModalite, MDuree } from '@argalis-apps/models';
import { CatalogConfigService } from '../../services/catalog-config/catalog-config.service';
import { SearchService } from '../../services/search/search.service';
import { forkJoin } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

@Component({
  selector: 'ags-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  advancedMode: boolean;
  searchForm: UntypedFormGroup;

  // Criteres de recherche
  postCode: string;
  domaineSelected: MDomain.IDomain = null;

  // Catalogue de données
  listDomaine: MDomain.IDomain[] = [];
  listModalite: MModalite.IModalite[] = [];
  listDureeOption: MDuree.IDuree[] = [];
  backgroundPictureUri = '';

  constructor(
    private route: ActivatedRoute,
    private configService: ConfigService,
    private catalogConfigService: CatalogConfigService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private searchService: SearchService,
    private toolsService: ToolsService
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${catalogConfigService.themingClassName}`;
    this.searchForm = this.formBuilder.group({
      searchText: [''],
      dateDebut: [null],
      dateFin: [null],
      dureeOptionId: [0],
      modaliteId: [0],
      postCode: ['']
    });
  }

  ngOnInit() {
    forkJoin(
      this.searchService.getDomOptionList(),
      this.searchService.getDureeOptionList(),
      this.searchService.getModaOptionList(),
      this.searchService.getBackgroundPicture()
    ).subscribe(
      (all: any) => {
        this.listDomaine = [{ id: 0, libelle: 'Tous nos domaines', type: '', children: [] }];
        this.listDomaine.push(...all[0]);
        this.listDureeOption = [{ id: 0, libelle: 'Durée' }];
        this.listDureeOption.push(...all[1]);
        this.listModalite = [{ id: 0, libelle: 'Modalité' }];
        this.listModalite.push(...all[2]);
        this.backgroundPictureUri = (all[3] || ({} as any)).data;
        this.route.queryParams.subscribe(async params => {
          this.initSearchFromParams(params);
        });
      },
      err => console.log(err)
    );
  }

  initSearchFromParams(params): any {
    this.domaineSelected =
      this.toolsService.findInHierarchyTab(
        this.listDomaine,
        dom => {
          return dom.id === parseInt(params.domId || '0', 10) && dom.type === params.domType;
        },
        'children'
      ) || this.listDomaine[0];
    this.postCode = params.postal || '';

    this.searchForm = this.formBuilder.group({
      searchText: [params.text || ''],
      dateDebut: [params.debut ? new Date(parseInt(params.debut, 10)) : undefined],
      dateFin: [params.fin ? new Date(parseInt(params.fin, 10)) : undefined],
      dureeOptionId: [parseInt(params.duree || '0', 10)],
      modaliteId: [parseInt(params.moda || '0', 10)],
      postCode: [params.postal || '']
    });
  }

  execSearch() {
    this.router.navigate([`/${this.catalogConfigService.routingBaseUri}/searchresult`], {
      queryParams: this.getSearchParams()
    });
  }

  private getSearchParams() {
    const searchParams = {};

    if (this.searchForm.value.searchText) {
      Object.assign(searchParams, { text: this.searchForm.value.searchText });
    }
    if (this.searchForm.value.dateDebut) {
      Object.assign(searchParams, { debut: this.searchForm.value.dateDebut.getTime() });
    }
    if (this.searchForm.value.dateFin) {
      Object.assign(searchParams, { fin: this.searchForm.value.dateFin.getTime() });
    }
    if (this.domaineSelected) {
      Object.assign(searchParams, { domId: this.domaineSelected.id });
      Object.assign(searchParams, { domType: this.domaineSelected.type });
    }
    if (this.searchForm.value.dureeOptionId) {
      Object.assign(searchParams, { duree: this.searchForm.value.dureeOptionId });
    }
    if (this.searchForm.value.modaliteId) {
      Object.assign(searchParams, { moda: this.searchForm.value.modaliteId });
    }
    if (this.searchForm.value.postCode) {
      Object.assign(searchParams, { postal: this.searchForm.value.postCode });
    }

    return searchParams;
  }

  getBackgroundStyle() {
    if (this.backgroundPictureUri) {
      return {
        'background-image': `url('${this.backgroundPictureUri}')`,
        'background-repeat': 'no-repeat',
        'background-size': 'cover'
      };
    }
    return {};
  }

  onPostCodeValueChange(newVal: string) {
    setTimeout(() => {
      this.postCode = newVal.replace(/[^0-9]/gi, '').slice(0, 5);
    });
  }
}
